// extracted by mini-css-extract-plugin
export default {"list":"DetailedOptionsHistoryItem_list__WBCdx","list_item":"DetailedOptionsHistoryItem_list_item__ZrhbA"};